import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AuthContext from "../contexts/AuthContext";

// ===== STATIC IMPORTS FOR OFFLINE SUPPORT =====
// All components are imported statically to ensure they're bundled together
// and available offline. This is critical for PWA functionality.

// Core pages
import ScanDetails from "../pages/ScanDetails/ScanDetails";
import ViewLeads from "../pages/ViewLeads/ViewLeads";
import SponsoredEvent from "../pages/AllEvents";
import Profile from "../pages/Profile";
import TeamMembers from "../pages/TeamMembers";
import NoEventSponsor from "../pages/NoEventSponsor";
import SponsorAppTour from "../pages/SponsorAppTour";

// Modal pages
import DetailsCardModal from "../common/ModalPages/LeadDetailsModal";
import EditCommentModal from "../common/ModalPages/EditCommentModal";
import ScanLeadModal from "../common/ModalPages/ScanLeadModal";
import ShareSponsorCodeModal from "../common/ModalPages/ShareSponsorCodeModal";
import EnterSponsorCodeModal from "../common/ModalPages/EnterSponsorCode";
import EnterSponsorCodeFromHeader from "../common/ModalPages/EnterSponsorCodeFromHeader";

export default function AuthenticatedRoutes({ state }) {
  const Context = useContext(AuthContext);

  const getNavigateUrl = () => {
    if (
      Context.eventUpdate.length===0
    ) {
      return "/tour";
    } else {
      return "/events";
    }
  };
  return (
    <Routes>
      <Route path="/no-event" element={<NoEventSponsor />} />

      <Route path="/tour" element={<SponsorAppTour />} />

      <Route path="/events" element={<SponsoredEvent />}>
        <Route path="EnterSponsorCode" element={<EnterSponsorCodeModal />} />
        <Route path="ShareSponsorCode" element={<ShareSponsorCodeModal />} />
      </Route>

      {/* Legacy route redirect for backward compatibility */}
      <Route path="/Events" element={<Navigate to="/events" replace />} />

      <Route path="/events/:eventId/scanDetails" element={<ScanDetails />}>
        <Route path="ShareSponsorCode" element={<ShareSponsorCodeModal />} />
        <Route path="ScanLeadModal" element={<ScanLeadModal />}/>
        <Route path="DetailsCardModal" element={<DetailsCardModal />}>
          <Route path="EditCommentModal" element={<EditCommentModal />}></Route>
        </Route>
      </Route>

      {/* Legacy route redirect */}
      <Route path="/Events/:eventId/scanDetails" element={<Navigate to={window.location.pathname.toLowerCase()} replace />} />

      <Route path="/addEventModal" element={<EnterSponsorCodeFromHeader />} />

      <Route path="/profile" element={<Profile />} />

      <Route path="/events/:eventId/view-leads" element={<ViewLeads />}>
        <Route path="ShareSponsorCode" element={<ShareSponsorCodeModal />} />
        <Route path="DetailsCardModal" element={<DetailsCardModal />}>
          <Route path="EditCommentModal" element={<EditCommentModal />}></Route>
        </Route>
      </Route>

      {/* Legacy route redirect */}
      <Route path="/Events/:eventId/view-leads" element={<Navigate to={window.location.pathname.toLowerCase()} replace />} />

      <Route path="/events/:eventId/team" element={<TeamMembers />}>
        <Route path="ShareSponsorCode" element={<ShareSponsorCodeModal />} />
      </Route>

      {/* Legacy route redirect */}
      <Route path="/Events/:eventId/team" element={<Navigate to={window.location.pathname.toLowerCase()} replace />} />

      {Context.eventUpdate && (
        <Route path="/*" element={<Navigate to={getNavigateUrl()} replace />} />
      )}
    </Routes>
  );
}
